<ng-container [formGroup]="form">
    <td class="row-input">
        <cm-select
            formControlName="fieldType"
            [options]="options"
            [ngClass]="{ 'is-invalid': form.get('fieldType').invalid }"
            class="form-select"
            (blur)="onTouched()"
        >
        </cm-select>
    </td>
    <td class="row-input"><input formControlName="name" class="form-control" (blur)="onTouched()" /></td>
    <td class="row-input"><input formControlName="jsonName" class="form-control" (blur)="onTouched()" /></td>
    <button class="trash-btn reset-btn fa fa-2x fa-trash" (click)="_deleteField()"></button>
    <ng-container formGroupName="radioOptions">
        <table *ngIf="selectedType === 3">
            <thead>
                <th>Radio Option Display Name</th>
                <th>Radio Option Value</th>
            </thead>
            <tr *ngFor="let item of radioOptionsArray; let i = index">
                <ng-container [formGroupName]="item.pdfTemplateFieldRadioOptionId">
                    <td><input formControlName="displayName" class="form-control" (blur)="onTouched()" /></td>
                    <td><input formControlName="optionValue" class="form-control" (blur)="onTouched()" /></td>
                    <td><button class="trash-btn reset-btn fa fa-2x fa-trash" (click)="deleteItem(i)"></button></td>
                </ng-container>
            </tr>
            <tfoot>
                <button class="btn ch-button" (click)="addItem()">Add Radio Option</button>
            </tfoot>
        </table>
    </ng-container>
</ng-container>
